import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const EMS_PARTS_API_URL = process.env.REACT_APP_API_URL + "/ems-parts/";

const getPartsByPartsNumber = (clientId, pn) => {
  return axios.get(EMS_PARTS_API_URL + clientId + "/pn?pn=" + encodeURIComponent((pn ?? "").trim()), {headers: authHeader() })
}

const lookupPartsWithAiFallback = (clientId, pn) => {
  return axios.get(EMS_PARTS_API_URL + clientId + "/pn/ai-lookup?pn=" + encodeURIComponent((pn ?? "").trim()), {headers: authHeader() })
}

const getMakes = (make) => {
  return axios.get(EMS_PARTS_API_URL + "makes?make=" + encodeURIComponent(make), {headers: authHeader() })
}

const getModels = (makeId) => {
  return axios.get(EMS_PARTS_API_URL + "models?make=" + makeId, {headers: authHeader() })
}

const soldHistorySummary = (clientId, days) => {
  return axios.get(EMS_PARTS_API_URL + "report/" + clientId + "/soldHistorySummary?days=" + days, {headers: authHeader() })
}

const soldHistoryDetails = (pageRequest) => {
  return axios.post(EMS_PARTS_API_URL + "report/soldHistoryDetails", pageRequest, {headers: authHeader() })
}

const getPendingAiResults = (page = 0, size = 50) => {
  return axios.get(process.env.REACT_APP_API_URL + "/admin/parts-ai-results?page=" + page + "&size=" + size, {headers: authHeader() })
}

const confirmAiResult = (partsListId) => {
  return axios.post(process.env.REACT_APP_API_URL + "/admin/parts-ai-results/" + partsListId + "/confirm", {}, {headers: authHeader() })
}

const partsService = {
  getPartsByPartsNumber,
  lookupPartsWithAiFallback,
  getMakes,
  getModels,
  soldHistorySummary,
  soldHistoryDetails,
  getPendingAiResults,
  confirmAiResult
};

export default partsService
